import { QueryClient } from "@tanstack/react-query";
import { fetchTourSummaryData } from "@/hooks/product-detail-page/tour-summary/use-tour-summary";
import { StaticContent } from "@/types/dto/pdp/pdp-contentful";

const prefetchTourSummary = (
  queryClient: QueryClient,
  packageId: string,
  packageDateId: string,
  neoId: string,
  marketId: string,
  currencyId: string,
  staticContent: StaticContent
) => {
  queryClient.prefetchQuery({
    queryKey: ["PDP_TOUR_SUMMARY", neoId, packageId, packageDateId, currencyId, marketId],
    queryFn: fetchTourSummaryData(
      packageId,
      packageDateId,
      neoId,
      marketId,
      currencyId,
      staticContent
    ),
    staleTime: Infinity
  });
};

export default prefetchTourSummary;